import { useQuery } from '@tanstack/react-query';

import { Role } from 'src/features/role/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/users/role/`;

interface DTO extends ListDTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Role>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        staleTime: 1000 * 60 * 30,
        ...config,
    });

export { RESOURCE as LIST_ROLES_RESOURCE, useQueryHook as useListRoles };
